import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

//Serives
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { UpdateExport } from '../models/export.model';

@Injectable()
export class SharedExportService {

    baseLionoCoreURL: string;
    
    constructor(private httpService: HttpService) {
        this.baseLionoCoreURL = environment.apiUrl;
    }

    ExportData(exportData: Partial<UpdateExport>){
        return this.httpService.create(`${this.baseLionoCoreURL}ExportFile`, exportData);
    }

}
